import { z } from 'zod/v4';

export const orderStatusActionSchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal('grant_access') }),
  z.object({ type: z.literal('revoke_access') }),
  z.object({
    type: z.literal('send_notification'),
    templateId: z.number(),
  }),
  z.object({
    type: z.literal('trigger'),
    triggerId: z.number(),
  }),
  z.object({
    type: z.literal('webhook'),
    url: z.string().url(),
    method: z.enum(['GET', 'POST']),
    headers: z.record(z.string(), z.string()).optional(),
  }),
]);

export const createOrderStatusSchema = z.object({
  name: z.string().min(1, 'Название обязательно').max(100, 'Название слишком длинное'),
  description: z.string().max(500, 'Описание слишком длинное').optional(),
  color: z.string().regex(/^#[0-9A-Fa-f]{6}$/, 'Неверный формат цвета').optional().default('#6b7280'),
  position: z.number().int().min(0, 'Позиция не может быть отрицательной').optional().default(0),
  isInitial: z.boolean().optional().default(false),
  isFinal: z.boolean().optional().default(false),
  onEnterActions: z.array(orderStatusActionSchema).optional().default([]),
  onExitActions: z.array(orderStatusActionSchema).optional().default([]),
});

export const updateOrderStatusDefinitionSchema = createOrderStatusSchema.partial();

export const createStatusTransitionSchema = z.object({
  // fromStatusId может браться из URL params, поэтому optional
  fromStatusId: z.number().nullable().optional(),
  toStatusId: z.number(),
  requireNote: z.boolean().optional().default(false),
  requireConfirmation: z.boolean().optional().default(false),
});

export const reorderOrderStatusesSchema = z.object({
  statusIds: z.array(z.number()).min(1, 'Массив статусов обязателен'),
});

export type CreateOrderStatusInput = z.infer<typeof createOrderStatusSchema>;
export type UpdateOrderStatusDefinitionInput = z.infer<typeof updateOrderStatusDefinitionSchema>;
export type CreateStatusTransitionInput = z.infer<typeof createStatusTransitionSchema>;
export type ReorderOrderStatusesInput = z.infer<typeof reorderOrderStatusesSchema>;
export type OrderStatusAction = z.infer<typeof orderStatusActionSchema>;
